module.exports = __webpack_public_path__ + "static/media/qr.84f81278.png";